import {
    CUSTOMER_SUPPORT_WHATSAPP_LINK,
    WHATS_APP_CONTACT_PRIMARY_DISPLAY,
} from '../../../../constants/app.constant';

export interface AskPodPopupInterface {
    title?: string;
    planName?: string;
    hotlineNumber?: string;
    hotlineWhatsappUrl?: string;
}

export class AskPodPopupModel {
    title: string;
    planName: string;
    hotlineNumber: string;
    hotlineWhatsappUrl: string;

    constructor(model: AskPodPopupInterface) {
        this.title = model.title || 'askPodPopup.title';
        this.planName = model.planName || 'RM2888';
        this.hotlineNumber = model.hotlineNumber || WHATS_APP_CONTACT_PRIMARY_DISPLAY;
        this.hotlineWhatsappUrl = model.hotlineWhatsappUrl || CUSTOMER_SUPPORT_WHATSAPP_LINK;
    }
}
